import { jsx } from 'react/jsx-runtime';

const SvgFormDash = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M17 11H7v2h10v-2Z" }) }));

export { SvgFormDash as default };
//# sourceMappingURL=FormDash.es.js.map
